import * as $ from 'jquery';
import * as Ajax from '../utils/ajax.js';
import * as BI from '../tracking/bi.js';
import { canCallApp, arrayRemove, removeFadeOut, config } from '../utils';
import { onLoad } from '../utils/onLoad';

// Data models tracking (BI & Zendesk)
import { BuyBrandPersonalizeBIModel } from '../BI/models';
import personalize_sizes from '../components/personalize_sizes.js';

const containerSelectedBrands = document.querySelector('.selected-brands-container'),
      containerPopularBrands = document.querySelector('.js-popular-brands-container'),
      containerSearchBrands = document.querySelector('.js-search-brands-container');

onLoad(() => {
    personalize_sizes.init();

//
// BRANDS INI
    document.querySelectorAll('[name="brands[]"]').forEach(input => { //Setear las marcas populares y añadir listeners
        input.addEventListener('input', e => {
            if (input.checked) {
                addBrandToSelected(input.value);
            } else {
                removeBrandFromSelected(input.value);
            }
        });
    });
    document.querySelectorAll('.js-remove-brand').forEach(btn => btn.addEventListener('click', () => removeBrandFromSelected(btn.dataset.brandId))); //Añadir listener a marcas escogidas al cargar

    let typingTimer = null;
    const brandsInput = document.querySelector('.js-brands-input');
    if (brandsInput) {
        brandsInput.addEventListener('input', e => {
            if (!e.srcElement.value.length) {
                containerSearchBrands.querySelectorAll('div.custom-checkbox').forEach(div => div.remove());
                containerPopularBrands.classList.remove('d-none');
                containerSearchBrands.classList.add('d-none');
            }
        });
        brandsInput.addEventListener('keyup', e => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(searchBrands.bind(null, e.srcElement.value), 400);
        });
    }

    const brandsBtn = document.querySelector('.js-save-user-brands');
    if (brandsBtn) {
        brandsBtn.addEventListener('click', () => {
            let brandList = [];
            brandsBtn.toggleAttribute('disabled', true);
            document.querySelectorAll('.selected-brands-container [data-brand-id]').forEach((el) => {
                brandList.push(el.dataset.brandId);
            });

            const buyBrandPersonalizeBIModel = new BuyBrandPersonalizeBIModel(config.user.id, BI.trendView, brandList, brandList.length);
            BI.track(buyBrandPersonalizeBIModel);
            window.location.reload();
        });
    }
    document.querySelectorAll('.js-delete-user-brands').forEach(btn => btn.addEventListener('click', () => {
        btn.toggleAttribute('disabled', true);
        Ajax.post("/profile/json_remove_all_user_brands").then(() => {
            if (canCallApp("refreshUser")) {
                Trendier.refreshUser();
            }
            window.location.reload();
        });
    }));

    document.querySelectorAll('[data-alert]').forEach(el => {
        setTimeout(() => {
            el.remove();
        }, el.dataset.alert * 1000);
    });

    function searchBrands(brandname) //Gestión de buscador de marcas
    {
        const template = document.querySelector('#input-brand-template').content;
        if (brandname.length) //Si se ha escrito en el input, esconder marcas populares y limpiar y mostrar container de resultados
        {
            containerSearchBrands.querySelectorAll('div.custom-checkbox').forEach(div => div.remove());
            containerPopularBrands.classList.add('d-none');
            containerSearchBrands.classList.remove('d-none');
            containerSearchBrands.querySelector('.js-brands-loading').classList.remove('d-none'); //mostrar loader
            document.querySelector('.js-brands-no-result').classList.add('d-none');

            Ajax.get("/api/v4/brand/search", {
                name: brandname,
                limit: 10
            }, true)
            .then(brands => {
                containerSearchBrands.querySelector('.js-brands-loading').classList.add('d-none'); //esconder loader
                document.querySelector('.js-brands-no-result').classList.toggle('d-none', brands.length); //Si no hay coincidencias, mostrar mensaje "sin resultados"
                brands.forEach(brand => { // Por cada marca devuelta, se genera un custom checkbox, se rellena, se muestra y se le añaden los listeners
                    let brandInput = document.importNode(template, true).querySelector('div'),
                        input = brandInput.querySelector('input'),
                        label = brandInput.querySelector('label');
                    input.value = brand.id;
                    input.id = brand.id;
                    input.checked = isSelected(brand.id);
                    label.htmlFor = brand.id;
                    label.innerText = brand.name;
                    containerSearchBrands.appendChild(brandInput);
                    input.addEventListener('input', () => {
                        if (input.checked) {
                            addBrandToSelected(input.value);
                        } else {
                            removeBrandFromSelected(input.value);
                        }
                    });
                });
            });
        } else { //Si el input está vacío, limpiar y esconder container de resultados y mostrar marcas populares
            containerSearchBrands.querySelectorAll('div.custom-checkbox').forEach(div => div.remove());
            containerPopularBrands.classList.remove('d-none');
            containerSearchBrands.classList.add('d-none');
        }
    }

    function addBrandToSelected(brandId) // Dada una id, genera el botón de marca seleccionada, lo muestra y le añade los listeners. Tiene en cuenta la posibilidad de inputs duplicados haciéndoles check (marcas populares y marcas buscadas)
    {
        Ajax.post("/profile/json_add_user_brand/1", {brandId: brandId});

        if (canCallApp("refreshUser")) {
            Trendier.refreshUser();
        }

        const template = document.querySelector('#selected-brand-template').content;
        document.querySelectorAll('[name="brands[]"][id="' + brandId + '"]:checked ~ label').forEach(brand => {
            if (containerSelectedBrands) {
                let selectedBrand = document.importNode(template, true).querySelector('button');
                selectedBrand.querySelector('.js-brand-name').textContent = brand.textContent;
                selectedBrand.dataset.brandId = brandId;
                containerSelectedBrands.parentElement.classList.remove('d-none');
                containerSelectedBrands.prepend(selectedBrand);
                selectedBrand.addEventListener('click', () => removeBrandFromSelected(selectedBrand.dataset.brandId));
            }
        });
        document.querySelectorAll('[name="brands[]"][id="' + brandId + '"]').forEach(brandInput => brandInput.checked = true);
    }

    function removeBrandFromSelected(brandId) // Dada una id, elimina el botón de marca seleccionada. Tiene en cuenta la posibilidad de inputs duplicados haciéndoles uncheck (marcas populares y marcas buscadas)
    {
        Ajax.post("/profile/json_remove_user_brand/1", {brandId: brandId});

        if (canCallApp("refreshUser")) {
            Trendier.refreshUser();
        }

        document.querySelectorAll('[data-brand-id="' + brandId + '"]').forEach(brandBtn => {
            brandBtn.remove();
            if (!containerSelectedBrands.querySelectorAll('button').length) {
                containerSelectedBrands.parentElement.classList.add('d-none');
            }
        });
        document.querySelectorAll('[name="brands[]"][id="' + brandId + '"]').forEach(brandInput => brandInput.checked = false);
    }

    const isSelected = (brandId) =>
        !!document.querySelector('.selected-brands-container [data-brand-id="' + brandId + '"]');
    // BRANDS FIN
    //

    // ALERTS INI
    //

    const deleteAllUserAlertsBtn = document.querySelector('.js-delete-all-user-alert'),
          deleteUserAlertBtn = document.querySelector('.js-delete-user-alert'),
          closeUserAlertBtn = document.querySelector('.js-close-user-alert'),
          checkboxesUserAlert = document.querySelectorAll('input[name="alerts[]"]');
          const modalUserAlert = document.getElementById('js-modal-set-user-alert');

    let userAlertIdsAvailable = [],
        userAlertIdsAvailableInitial = [],
        userAlertIdsToDelete = [],
        userAlertIdsSeen = [];

    const getUserAlert = async (id) => await Ajax.get(`/profile/render_user_alert/${id}`, {}, false, false);
    const deleteUserAlert = async (id) => await Ajax.post(`/profile/json_remove_user_alert/`, {id});
    const deleteAllUserAlert = async () => await Ajax.post(`/profile/json_remove_all_user_alerts`, {});

    const updateModalAlertButtons = () => {
        deleteAllUserAlertsBtn.classList.add('d-none');
        deleteUserAlertBtn.classList.add('d-none');
        closeUserAlertBtn.classList.remove('d-none');
    }

    deleteUserAlertBtn?.addEventListener("click", () => {
        userAlertIdsAvailable.forEach(id => {
            const alertElement = document.getElementById(`alert-${id}`);
            if (alertElement.checked) {
                userAlertIdsToDelete.push(alertElement.value);
            }
        });
        if (userAlertIdsToDelete.length > 0) {
            userAlertIdsToDelete.map(async (id) => {
                const { error, result } = await deleteUserAlert(id);
                if (Object.keys(result).length !== 0 && result.success) {
                    const deleteDomAlert = document.querySelector(`.panel-${id}`);
                    const deleteDomAlertCheck = deleteDomAlert.querySelector('input[type="checkbox"]');
                    userAlertIdsAvailable = arrayRemove(userAlertIdsAvailable, id);
                    userAlertIdsToDelete = arrayRemove(userAlertIdsToDelete, id);
                    userAlertIdsSeen = arrayRemove(userAlertIdsSeen, id);
                    deleteDomAlertCheck.checked = false;
                    removeFadeOut(deleteDomAlert, 1000);

                    if (userAlertIdsAvailable.length === 0) {
                        updateModalAlertButtons();
                    }
                } else {
                    console.error(`Error on deleteUserAlert: ${error}`);
                }
            });
        }
    });

    deleteAllUserAlertsBtn?.addEventListener("click", async() => {
        userAlertIdsAvailable.forEach(id => {
            const alertElement = document.getElementById(`alert-${id}`);
            alertElement.checked = true;
            userAlertIdsToDelete.push(alertElement.value);
        });
        if (userAlertIdsToDelete.length > 0) {
            const { error, result } = await deleteAllUserAlert();
            if (Object.keys(result).length !== 0 && result.success) {
                const panelElement = modalUserAlert.querySelector('.panel-group');
                removeFadeOut(panelElement, 1000);
                userAlertIdsAvailable = [];
                updateModalAlertButtons();
            } else {
                console.error(`Error on deleteAllUserAlert: ${error}`);
            }
        }
    });

    checkboxesUserAlert.forEach((item) => {
        item.addEventListener('click', async(e) => {
            const isSomeCheck = [...checkboxesUserAlert].some(item => item.checked);
            const alertId = e.target.value;
            const innerContent = document.querySelector(`.js-content-alert-${ alertId }`);
            let dataAlert = {}

            if (!userAlertIdsSeen.includes(alertId)) {
                dataAlert = await getUserAlert(alertId);
                if (Object.keys(dataAlert).length > 0) {
                    userAlertIdsSeen.push(alertId);
                }
                innerContent.innerHTML = dataAlert;
            }

           deleteUserAlertBtn.disabled = !isSomeCheck;
        })
    });


    $('#js-modal-set-user-alert').on('shown.bs.modal', async () => {
        // Initial Checkbox ID available
        checkboxesUserAlert.forEach(item => {
            userAlertIdsAvailable.push(item.value);
        });
        userAlertIdsAvailableInitial = [...userAlertIdsAvailable];
    });

    $('#js-modal-set-user-alert').on('hidden.bs.modal', () => {

        if (!(userAlertIdsAvailableInitial.length === userAlertIdsAvailable.length && userAlertIdsAvailableInitial.every((v, i) => v === userAlertIdsAvailable[i]))) {
            window.location.reload();
        }

        userAlertIdsAvailable = [];
        userAlertIdsAvailableInitial = [];
        userAlertIdsToDelete = [];
    })

    // ALERTS FIN
    //

});
